export default {
  delete: ({ DELETE }, idVille) =>
    new Promise((resolve, reject) => {
      if (!idVille) {
        reject(new Error(`Erreur paramètre : idVille non valide "${idVille}"`))
      }
      return DELETE(`donnees/villes/${idVille}`)
        .then((reponse) => {
          const data = reponse.data
          if ([200, 204].includes(reponse.status)) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
}
